/** Une adresse e-mail plausible. */
export const EMAIL_VALIDE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * L'adresse de la fiche à laquelle le serveur envoie l'offre : celle de
 * correspondance, sinon la principale, sinon celle des factures.
 *
 * @param {object} [client] client de l'offre
 * @returns {string} l'adresse, vide sans aucune
 */
export function adresseDeLaFiche(client) {
  if (!client) return '';
  return String(client.emailCorr || client.email || client.emailFactures || '').trim();
}

/**
 * Toutes les adresses qui reçoivent l'offre en un seul e-mail : la fiche du
 * client puis les autres notées sur l'offre, sans doublon.
 *
 * @param {object} [client] client de l'offre
 * @param {string[]} [autres] autres adresses de l'offre
 * @returns {string[]} les adresses, dans l'ordre
 */
export function adressesDeLOffre(client, autres) {
  const toutes = [];
  [adresseDeLaFiche(client), ...(autres || [])].forEach((a) => {
    const adresse = String(a || '').trim();
    if (adresse && !toutes.some((t) => t.toLowerCase() === adresse.toLowerCase())) {
      toutes.push(adresse);
    }
  });
  return toutes;
}

/**
 * L'adresse de la fiche à laquelle le serveur envoie une facture ou un
 * rappel : celle des factures, sinon la principale, sinon la correspondance.
 *
 * @param {object} [client] client de la facture
 * @returns {string} l'adresse, vide sans aucune
 */
export function adresseDeFacturation(client) {
  if (!client) return '';
  return String(client.emailFactures || client.email || client.emailCorr || '').trim();
}

/**
 * Toutes les adresses qui reçoivent la facture et ses rappels en un seul
 * e-mail : la fiche (adresse des factures) puis les autres, sans doublon.
 *
 * @param {object} [client] client de la facture
 * @param {string[]} [autres] autres adresses de la facture
 * @returns {string[]} les adresses, dans l'ordre
 */
export function adressesDeLaFacture(client, autres) {
  return adressesDeLOffre({ email: adresseDeFacturation(client) }, autres);
}
